import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { createFetcher } from '../libs/next/api/jsonApiHandler'
import type { API } from '../pages/api/filter/[handler]'
import { useActiveDog } from '../src/user/ActiveDogContext'

const api = createFetcher<API>('/api/filter/[handler]')

export function useAllProductIds(productId: string) {
	const { dog: dogInfo } = useActiveDog()

	const allProducts = useQuery({
		queryKey: ['allProductIds', dogInfo],
		queryFn: async () => {
			return api('allProductIds', { dogInfo })
		},
		placeholderData: keepPreviousData,
	})

	const productIds = (allProducts?.data?.items ?? []).map((product) => product.id)

	return {
		ids: productIds,
		productIndex: productIds?.indexOf(productId) ?? undefined,
		isFed: productId === dogInfo?.fedProduct,
		isTopFirst: productIds?.indexOf(productId) === 0,
	}
}
